import { CommentIcon, EllipsisIcon, ExportIcon } from "@xola/icons";
import { Popover } from "@xola/ui-kit";
import clsx from "clsx";
import { DateFormat, dateToStr, formatDate } from "common";
import dayjs from "dayjs";
import React, { useState } from "react";
import { Timeslot } from "types";
import { DayHeaderContentArg } from "@fullcalendar/common";
import { Menu } from "../../Common/Menu";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { Translate } from "../../Common/Translate";
import { ExportRosterModal } from "../../Event/ExportRosterModal";
import { MessageDayEventsModal } from "../../Event/MessageDayEventsModal";

export const DayHeaderContent = ({ fcEvents, date, isToday }: DayHeaderContentArg) => {
    const [showExportRosterModal, setShowExportRosterModal] = useState(false);
    const [showMessageDayEventsModal, setShowMessageDayEventsModal] = useState(false);
    const currentDate = dayjs.tz(date);
    let reservedCount = 0;
    for (const fcEvent of fcEvents) {
        const { timeslot }: { timeslot: Timeslot } = fcEvent; // Otherwise you don't know the type for `reserved`
        if (timeslot?.date === formatDate(date)) {
            reservedCount += timeslot.capacity.reserved;
        }
    }

    const eventIds = fcEvents
        .filter(
            (fcEvent: any) =>
                fcEvent.timeslot?.event &&
                fcEvent.timeslot.capacity.reserved > 0 &&
                fcEvent.timeslot.date === formatDate(date),
        )
        .map((fcEvent: any) => fcEvent.timeslot.event.id);

    // Fullcalendar gives us a Date object starting midnight in **YOUR** timezone.
    // Extract it in string form, so that we get rid of the timezone component, and then get the unix from it
    const start = dayjs.utc(dateToStr(date)).unix();
    const end = dayjs.utc(dateToStr(date)).endOf("day").unix();

    return (
        <div className={clsx("py-2 text-sm font-semibold")}>
            <Translate if={isToday} className={clsx(isToday && "text-primary")}>
                {/* Day of the week in week view */}
                {isToday ? "Today" : dayjs(date).format("ddd Do")}
            </Translate>
            {reservedCount > 0 && (
                <Popover placement="bottom" appendTo={document.body} trigger="click">
                    <SecondaryButton size="tiny" className="invisible absolute right-2 group-hover:visible">
                        <EllipsisIcon />
                    </SecondaryButton>

                    <Popover.Content>
                        <Menu>
                            <Menu.Item icon={<CommentIcon />} onClick={() => setShowMessageDayEventsModal(true)}>
                                Message Day&apos;s Reservations
                            </Menu.Item>

                            {/* TODO: Icon is invisible for unknown reason. Need to fix. */}
                            <Menu.Item icon={<ExportIcon />} onClick={() => setShowExportRosterModal(true)}>
                                Export Day&apos;s Roster
                            </Menu.Item>
                        </Menu>
                    </Popover.Content>
                </Popover>
            )}
            <MessageDayEventsModal
                isOpen={showMessageDayEventsModal}
                eventIds={eventIds}
                date={formatDate(currentDate, DateFormat.DATE_ISO)}
                onClose={() => setShowMessageDayEventsModal(false)}
            />
            <ExportRosterModal
                filters={{
                    format: "roster",
                    reserved: true,
                    start,
                    end,
                }}
                isOpen={showExportRosterModal}
                onClose={() => setShowExportRosterModal(false)}
            />
        </div>
    );
};
